import React from 'react';
import { Icon } from '@chakra-ui/icons';

export const InstagramIcon = ({ color = 'white' }: { color?: string }) => {
	return (
		<Icon
			width="auto"
			height={{ base: '7px', hashup: '10px' }}
			viewBox="0 0 17 17"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M12.0402 1.25781H4.62081C2.57201 1.25781 0.911133 2.91869 0.911133 4.96749V12.3868C0.911133 14.4356 2.57201 16.0965 4.62081 16.0965H12.0402C14.089 16.0965 15.7498 14.4356 15.7498 12.3868V4.96749C15.7498 2.91869 14.089 1.25781 12.0402 1.25781Z"
				stroke={color}
				strokeWidth="1.48387"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M11.2982 8.20967C11.3897 8.82715 11.2843 9.45777 10.9968 10.0118C10.7093 10.5659 10.2544 11.0152 9.69679 11.2959C9.13921 11.5765 8.50733 11.6742 7.89104 11.575C7.27474 11.4759 6.7054 11.1849 6.26401 10.7435C5.82262 10.3021 5.53164 9.73277 5.43247 9.11648C5.3333 8.50018 5.43098 7.8683 5.71163 7.31072C5.99228 6.75314 6.44159 6.29825 6.99567 6.01075C7.54974 5.72326 8.18037 5.61779 8.79784 5.70935C9.42769 5.80275 10.0108 6.09624 10.461 6.54648C10.9113 6.99672 11.2048 7.57983 11.2982 8.20967Z"
				stroke={color}
				strokeWidth="1.48387"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M12.4114 4.59668H12.4192"
				stroke={color}
				strokeWidth="1.48387"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Icon>
	);
};
